import "./TimerOption.scss"

type TimerOptionProps = {
  minutes: string
  onClick?: (minutes: string) => void
  cycleIsBreak?: boolean
}

function TimerOption(props: TimerOptionProps) {
  return (
    <div
      className={`TimerOption TimerOption--${
        props.cycleIsBreak ? "break" : "work"
      }`}
      onClick={() => props.onClick?.(props.minutes)}
    >
      <span className="TimerOption__minutes">{props.minutes}</span>
      <span className="TimerOption__label">minutes</span>
    </div>
  )
}

export default TimerOption
